import React from "react";

const ALL_SPORTS = ["ALL", "NBA", "NFL", "NHL", "MLB"];

export function SportTabs({ value, onChange, counts = {} }) {
  // Only show ALL + sports with at least 1 prop
  const visible = ALL_SPORTS.filter(
    (s) => s === "ALL" || (counts[s] || 0) > 0
  );
  return (
    <nav className="flex items-center gap-8 border-b border-[#27272A]" data-testid="sport-tabs">
      {visible.map((s) => {
        const total = s === "ALL" ? Object.values(counts).reduce((a, b) => a + b, 0) : (counts[s] || 0);
        return (
          <button
            key={s}
            data-active={value === s}
            data-testid={`sport-tab-${s.toLowerCase()}`}
            onClick={() => onChange(s)}
            className="sport-tab flex items-center gap-2"
          >
            <span>{s}</span>
            <span className="font-data text-xs text-[#52525b]">{total}</span>
          </button>
        );
      })}
    </nav>
  );
}
